import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About Me</h2>
        </ScrollAnimation>
        
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p className="intro">
            Tech enthusiast & visionary community leader with a B.Tech in Computer Science and Engineering, passionate about building the future with AI.
          </p>
        </ScrollAnimation>

        <div className="highlights">
          <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
            <div className="highlight-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <div className="content">
                <h3>GenAI Engineer @ Capgemini</h3>
                <p>Building cutting-edge generative AI solutions, multi-agent systems, and automating enterprise workflows with LLMs</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}>
            <div className="highlight-card">
              <div className="icon gold">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <div className="content">
                <h3>Gold Microsoft Learn Student Ambassador</h3>
                <p>Leading technical workshops, mentoring developers & building communities around Cloud, AI & Innovation</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
            <div className="highlight-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div className="content">
                <h3>Community Organizer & Leader</h3>
                <p>Organized numerous workshops, events & hackathons while guiding newcomers in their tech journey</p>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animateIn="fadeInUp" delay={0.5 * 1000}>
            <div className="highlight-card">
              <div className="icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
                </svg>
              </div>
              <div className="content">
                <h3>Open Source Advocate</h3>
                <p>Dedicated to community-driven growth, inspiring others to explore, innovate & excel in technology</p>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </div>
      
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.20 * 1000}>
          <img src="/Images/profile.jpg" alt="Kirti Kamal" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
